import React from 'react';
import ContactFormSv from './ContactFormSv';

const HomeSv = () => {
  const puhelin = '+358408675730';
  const email = 'jbyggoy@gmail.com';

  return (
    <div className="main" style={{ padding: '32px' }}>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          maxWidth: '1200px',
          margin: '0 auto'
        }}
      >
        {/* Left side: Contact info */}
        <div style={{ flex: '1', minWidth: '300px', paddingRight: '16px' }}>
          <div className="company-info" style={{ marginTop: '24px', color: '#000000', fontSize: '20px' }}>
            <h2>Byggtjänster i Borgå och närområden</h2>
            <p>
              Jbygg är ett byggföretag som grundades 2021 och erbjuder ett brett utbud av tjänster för byggprojekt.
              Du hittar mer information och bilder på våra arbeten genom att klicka på länkarna i menyn ovan.
              Kontakta oss för en offert!
            </p>
            <p>Palvelemme myös suomeksi!</p>
          </div>
          <div className="contact-info" style={{ marginTop: '16px', color: '#000000', fontSize: '20px' }}>
            <p>
              <strong>Joni Pirtelä</strong>
            </p>
            <p>
              <strong>Telefon:</strong> <a href={`tel:${puhelin}`} style={{ color: '#000000' }}>{puhelin}</a>
            </p>
            <p>
              <strong>E-post:</strong> <a href={`mailto:${email}`} style={{ color: '#000000' }}>{email}</a>
            </p>
          </div>
        </div>

        {/* Right side: Contact form (Swedish version) */}
        <div style={{ flex: '1', minWidth: '300px', paddingLeft: '16px' }}>
          <ContactFormSv />
        </div>
      </div>
    </div>
  );
};

export default HomeSv;
